import { axiosUtil } from "../../utils/axios_util";

const chooseCompanyApi = {
  //查询当前用户的企业列表
  orgList() {
    return axiosUtil({
      url: "/login/get_user_organization_list",
      method: "get",
    });
  },
  //用户登录选择绑定企业id
  chooseOrganization(data: string) {
    return axiosUtil({
      url: `/login/bind_organization/${data}`,
      method: "get",
      data,
    });
  },

  //获取临时上传地址
  fileUpload(data: any) {
    return axiosUtil({
      url: `/customer/auth/pre_signed_put`,
      method: "POST",
      data,
    });
  },
  //校验注册资金和成立日期
  checkCustomer(data: any) {
    return axiosUtil({
      url: `/customer/auth/check`,
      method: "POST",
      data,
    });
  },
  //校验客户经理
  checkManagerCode(data: any) {
    return axiosUtil({
      url: `/customer/auth/get_manager_code`,
      method: "POST",
      data,
    });
  },
  //获取手机验证码
  getPhoneCode(data: any) {
    return axiosUtil({
      url: `/customer/auth/send_sms`,
      method: "POST",
      data,
    });
  },
  //手机验证码校验
  checkPhoneCode(data: any) {
    return axiosUtil({
      url: `/customer/auth/check_sms_code`,
      method: "POST",
      data,
    });
  },
  //场景字典
  sceneList() {
    return axiosUtil({
      url: `/customer/auth/scene/dict`,
      method: 'post',
    })
  },

  //微信活体检测接口 生成二维码的地址
  wxCheckURL(data: any) {
    return axiosUtil({
      url: `/customer/auth/wx_check`,
      method: "POST",
      data,
    });
  },

  //查询微信活体检测是否成功
  wxCheckURLResult(data: any) {
    return axiosUtil({
      url: `/customer/auth/wx_check/result`,
      method: "POST",
      data,
    });
  },

  //门户平台新增企业客户和企业客户账户接口
  customerAdd(data: any) {
    return axiosUtil({
      url: `/customer/auth/add`,
      method: "POST",
      data,
    });
  },

  //获取企业准入客户经理字典
  get_manager_code(data:any) {
    return axiosUtil({
      url: `/customer/auth/get_manager_code`,
      method: "post",
      data
    });
  },
  //获取申请相关文件临时下载地址, 有效期为60分钟
  getFileUrl(objectName:string) {
    return axiosUtil({
      url: `/customer/auth/get_file_url?objectName=${objectName}`,
      method: 'GET',
    })
  },
//门户平台企业认证变更记查看详情
  getDetail(type:number) {
    return axiosUtil({
      url: `/customer/auth/detail/${type}`,
      method: 'POST',
    })
  },
  //门户平台企业认证变更记分页查询
  customerAuthPage(data:any) {
    return axiosUtil({
      url: `/customer/auth/page/${data.type}`,
      method: 'POST',
      data,
      params: {
        page: data.page,
        size: data.size
      }
    })
  },
//查看审核详情
  approvalList(id:any) {
    return axiosUtil({
      url: `/customer/auth/get_approval_node_list/${id}`,
      method: 'POST',
    })
  },

  //企业认证变更
  customerAuthUpdate(data: any) {
    return axiosUtil({
      url: `/customer/auth/update/${data.type}`,
      method: "POST",
      data,
    });
  },
//获取所有开启了其他项页面输入框的场景字典
  getOtherScenes(data:string ) {
    return axiosUtil({
      url: `/dictionary_manager/getByType`,
      method: "GET",
      params: {dictionaryType:data},
    });
  },



};

export default chooseCompanyApi;
